import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { TextTools } from 'appshared/text-tools';
import { MiscTools } from 'appshared/misc-tools';
import { UITools } from 'appshared/ui-tools';

import { AuthService } from 'client/app/services/auth.service';

@Component({
	selector: 'app-card-key-product',
	templateUrl: './card-key-product.component.html',
	styleUrls: ['./card-key-product.component.scss']
})
export class CardKeyProductComponent implements OnInit {
	@Input() parentApi !: any;
	@Input() object: Models.LicenseProduct = null;
	@Input() options: any = {};

	ac = AppConstants;
	tt = TextTools;
	mt = TextTools;

	now = new Date();

	debug: boolean = false;
	debugTime = new Date();
	loading: boolean = false;
	working: boolean = false;
	authUser: Models.AuthUser = null;

	objectToShow: Models.LicenseProduct = null;

	// options


	nameToShow: string = '[name]';
	typeToShow: string = '[type]';
	iconToShow: any = null;
	infoLines: string[] = [];
	extraLines: string[] = [];


	// ------------------------------------------------------------------------
	constructor(
		private router: Router,
		private authService: AuthService) {

		// this.router.routeReuseStrategy.shouldReuseRoute = function () {
		// 	return false;
		// };
	} // 

	// ------------------------------------------------------------------------
	ngOnInit(): void {
		const sessionUser: Models.AuthUser = this.authService.getUser();
		if (sessionUser != null && sessionUser.id !== 0) {
			this.authUser = sessionUser;
			this.setups();
		} // if
	}

	// ------------------------------------------------------------------------
	async setups() {
		this.loading = true;

		let optionKeys: string[] = [];
		if (this.options) optionKeys = Object.keys(this.options);

		// if (optionKeys.includes('includeClickInfo')) this.includeClickInfo = this.options.includeClickInfo;
		// if (optionKeys.includes('extraStyles')) this.extraStyles = this.options.extraStyles;
		// if (optionKeys.includes('extraClasses')) this.extraClasses = this.options.extraClasses;
		// if (optionKeys.includes('dark')) this.dark = this.options.dark;
		// if (optionKeys.includes('superscriptLevels')) this.superscriptLevels = this.options.superscriptLevels;

		this.setObject(this.object);
	}

	// ------------------------------------------------------------------------
	async setObject(object: Models.LicenseProduct) {

		this.objectToShow = MiscTools.deepClone(object);

		if (!this.objectToShow) return;

		this.nameToShow = this.objectToShow.label;
		this.typeToShow = 'Key Product';
		this.iconToShow = AppConstants.sectionIcons.licensingadmin;

		this.infoLines = [];

		this.infoLines.push('Internal Name: ' + this.objectToShow.name);
		this.infoLines.push('Label (Staff): ' + this.objectToShow.label);
		this.infoLines.push('Label (Non-Staff): ' + this.objectToShow.basic_label);
		if (this.objectToShow.description && this.objectToShow.description !== '')
			this.infoLines.push('Description: ' + this.objectToShow.description);

		if (this.objectToShow.show_meters >= 0 && this.objectToShow.show_meters < AppConstants.keyProductStatsValues.length)
			this.infoLines.push('Meter Stats: ' + AppConstants.keyProductStatsValues[this.objectToShow.show_meters]);

		if (this.objectToShow.show_protocols >= 0 && this.objectToShow.show_protocols < AppConstants.keyProductStatsValues.length)
			this.infoLines.push('Protocol Stats: ' + AppConstants.keyProductStatsValues[this.objectToShow.show_protocols]);

		if (this.objectToShow.meterProductsArr && this.objectToShow.meterProductsArr.length > 0)
			this.infoLines.push('Meter Products: ' + this.objectToShow.meterProductsArr.join(', '));

		this.infoLines.push('Name for License File: ' + this.objectToShow.license_filename);
		this.infoLines.push('Minimum Version: ' + this.objectToShow.min_version);
		this.infoLines.push('License Version: ' + this.objectToShow.fulfillment_version);
		this.infoLines.push('License Product: ' + this.objectToShow.fulfillment_product);

		this.infoLines.push('Added: ' + TextTools.formatDateNiceUTC(this.objectToShow.added_on));
		if (this.objectToShow.edited_on && this.objectToShow.edited_on !== this.objectToShow.added_on) this.infoLines.push('Edited: ' + TextTools.formatDateNiceUTC(this.objectToShow.edited_on));

		this.extraLines = [];
	} //


	// ------------------------------------------------------------------------
	debugMessage(theMsg: string) {
		if (this.debug) {
			const now = new Date();
			const ms = now.getTime() - this.debugTime.getTime();
			console.log('con.primt.card ' + ms.toLocaleString() + ' - ' + theMsg);
		}
	} // debugMessage}

}
